<template>
  <div>
    <b-row>
        <b-col md="1">
        </b-col>
        <b-col md="10" align-self="center">
            <b-form @submit="createPayment()">
                <b-form-group label-align="right" :label="$t('Payment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="number" v-model="paymentData.payment_incurrency" pattern="\d+(\.\d{2})?"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-select id="currencies"
                        :options="currencies"
                        required
                        v-model="paymentData.currency_id">
                    </b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Payment date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="date"  v-model="actual_date"/>
                    <b-form-checkbox v-model="isSetBurnTime">{{ $t('Set burn time') }}</b-form-checkbox>
                </b-form-group>
                <b-form-group label-align="right" v-if="isSetBurnTime" :label="$t('Burn date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-input type="date" v-model="burn_time" />
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Payment method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                    <b-form-select id="method"
                        :options="methods"
                        required
                        v-model="paymentData.method">
                    </b-form-select>
                </b-form-group>
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-payment-settings variant="outline-sucess">{{ $t('OtherSettings') }}</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-payment-settings" accordion="accordion-payment-settings" role="tabpanel">
                    <b-card-body>
                      <b-form-group label-align="right" :label="$t('Admin comment')" label-cols="5" label-cols-xl="5" label-cols-md="5">
                    <b-form-input type="text" v-model="paymentData.admin_comment"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-input type="text" v-model="paymentData.comment"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Payment extern number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-input type="text" v-model="paymentData.payment_ext_number"/>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Invoice number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-input-group>
                            <b-form-input type="number" v-model="paymentData.payment_to_invoice" disabled/>
                            <b-input-group-append>
                                <b-btn size="sm" @click="showModal()" variant="success">{{ $t('Invoices') }}</b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Turn on inet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-checkbox v-model="paymentData.turn_on_inet"></b-form-checkbox>
                    </b-form-group>
                    <b-form-group label-align="right" :label="$t('Write out a receipt')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                        <b-form-checkbox v-model="isTypeReceipt"></b-form-checkbox>
                    </b-form-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-row style="padding:10px">
                  <b-col>
                    <b-button variant="success" style="float: right; width: 100px" @click="createPayment()">{{ $t('Save') }}</b-button>
                  </b-col>
                  <b-col sm="1.5">
                    <b-button variant="secondary" style="float: right; width: 100px" @click="close()">{{ $t('Cancel') }}</b-button>
                  </b-col>
                </b-row>
            </b-form>
        </b-col>
    </b-row>

    <b-modal ref="myModalRef" hide-footer
    >
      <Invoices v-if="isShowInvoices" :userId="userId" :accountId="accountId" @clickOnInvoice="clickOnInvoice" ></Invoices>
      <b-btn class="mt-3" variant="secondary" block @click="hideModal">{{ $t('Cancel') }}</b-btn>
    </b-modal>
  </div>
</template>

<style>
.b-input-group {
    padding: 10px
}
</style>

<script>
import axiosInstance from '@/utils/api.js'
import Invoices from '@/pages/reports/Invoices.vue'
import download from 'downloadjs'

export default {
  components: {
    Invoices
  },
  props: {
    accountId: null,
    userId: null
  },
  data () {
    return {
      fileName: '.Receipt',
      isTypeReceipt: false,
      isShowInvoices: false,
      isSetBurnTime: false,
      actual_date: 0,
      burn_time: 0,
      paymentData: {
        'account_id': 0,
        'user_id': 0,
        'payment_incurrency': 0.0,
        'currency_id': 810,
        'actual_date': 0,
        'burn_time': 0,
        'method': 1,
        'admin_comment': '',
        'comment': '',
        'payment_ext_number': '',
        'payment_to_invoice': 0,
        'turn_on_inet': 0
      },
      currencies: [],
      methods: [],
      errorTitle: null,
      errorContent: null,
      userInfo: null
    }
  },
  async mounted () {
    this.userInfo = await axiosInstance.get(this.$store.getters.API_USERS_FULL_INFO + '?user_id=' + this.userId).then(response => { return response.data })
    axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_CURRENCIES).then(response => {
      var data = response.data
      for (var i in data) {
        let newCurrency = {}
        newCurrency.value = data[i].currency_id
        newCurrency.text = data[i].currency_brief_name
        this.currencies.push(newCurrency)
      }
    })
    axiosInstance.get(this.$store.getters.API_TARIFFING_PAYMENTS_METHODS).then(response => {
      var data = response.data
      for (var i in data) {
        let newMethod = {}
        newMethod.value = data[i].id
        newMethod.text = data[i].name
        this.methods.push(newMethod)
      }
    })
    var d = new Date()
    var month = '' + (d.getMonth() + 1)
    var day = '' + d.getDate()
    var year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    this.actual_date = this.burn_time = [year, month, day].join('-')
    if (this.userInfo.binded_currency_id) {
      this.paymentData.currency_id = this.userInfo.binded_currency_id
    }
  },
  methods: {
    close () {
      this.$emit('close', null)
    },
    async createPayment () {
      if (!this.paymentData.method) {
        this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Check payment method'), 'Warning')
        return
      }
      this.paymentData.payment_incurrency = Number(this.paymentData.payment_incurrency)
      if (this.paymentData.payment_incurrency === 0) {
        this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Check payment amount'), 'Warning')
      } else {
        this.paymentData.account_id = this.accountId
        this.paymentData.user_id = this.userId
        this.paymentData.actual_date = Number(Date.parse(this.actual_date)) / 1000
        if (this.isSetBurnTime) {
          this.paymentData.burn_time = Number(Date.parse(this.burn_time)) / 1000
        } else {
          this.paymentData.burn_time = 0
        }
        await axiosInstance.post(this.$store.getters.API_TARIFFING_PAYMENTS, this.paymentData).then(response => {
          if (this.isTypeReceipt) {
            this.fileName += '.pdf'
            axiosInstance.get(this.$store.getters.API_USERS_DOCUMENTS + '?user_id=' + this.userId + '&base_id=' + this.accountId + '&doc_type=5&file_type=1', {
              responseType: 'blob'}).then(response => {
              download(response.data, this.fileName, 'application/pdf')
            })
          }
        })

        this.$root.$emit('makeToasts')
        this.$emit('refreshTable')
        this.close()
      }
    },
    clickOnInvoice (invoiceId) {
      this.$refs.myModalRef.hide()
      this.paymentData.payment_to_invoice = invoiceId
      this.isShowInvoices = false
    },
    showModal () {
      this.isShowInvoices = true
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.isShowInvoices = false
      this.$refs.myModalRef.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/formPayment.vue